<button
  type="button"
  (click)="toggleTheme()"
  class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white xl:h-11 xl:w-11"
  aria-label="Toggle theme"
  title="Toggle theme"
>
  @if ((theme$ | async) === 'dark') {
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 3.75V2.75M12 21.25V20.25M4.22 4.22L4.93 4.93M19.07 19.07L19.78 19.78M3.75 12H2.75M21.25 12H20.25M4.22 19.78L4.93 19.07M19.07 4.93L19.78 4.22M16.25 12C16.25 14.35 14.35 16.25 12 16.25C9.65 16.25 7.75 14.35 7.75 12C7.75 9.65 9.65 7.75 12 7.75C14.35 7.75 16.25 9.65 16.25 12Z"
        stroke="currentColor"
        stroke-width="1.7"
        stroke-linecap="round"
      />
    </svg>
  } @else {
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M21 14.15C19.82 16.97 17.04 19 13.75 19C9.47 19 6 15.53 6 11.25C6 7.96 8.03 5.18 10.85 4C10.35 5.02 10.07 6.16 10.07 7.36C10.07 11.54 13.46 14.93 17.64 14.93C18.84 14.93 19.98 14.65 21 14.15Z"
        stroke="currentColor"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  }
</button>
